import React from 'react';
import { Editor, Location, Selection } from 'slate';
import { ReactEditor } from 'slate-react';
import { insertAndUpload } from './insertAndUpload';
import { AulaEditorContext, AulaEditorInstance } from '../types';

const isDragEvent = (
  event: React.DragEvent | React.ClipboardEvent,
): event is React.DragEvent =>
  (event as React.DragEvent<any>).dataTransfer !== undefined;

export const insertFilesFromEvent = (
  editor: AulaEditorInstance,
  event: React.DragEvent | React.ClipboardEvent,
  context: Omit<AulaEditorContext, 'entities'>,
  at?: Location | Selection,
) => {
  const files: FileList | File[] = isDragEvent(event)
    ? Array.from(event.dataTransfer.items).map(
        (item) => item.getAsFile() as File,
      )
    : Array.from(event.clipboardData.files);

  // prevent default only if files are dropped
  if (!files || files.length <= 0) {
    return;
  }

  event.preventDefault();

  files.forEach((file) => {
    if (!file) {
      return;
    }
    const end = Editor.edges(
      editor,
      at || Editor.path(editor, ReactEditor.findEventRange(editor, event)),
    )[1];

    const range = {
      anchor: end,
      focus: end,
    };

    insertAndUpload({
      file,
      range,
      editor,
      context,
    });
  });

  setTimeout(() => {
    ReactEditor.focus(editor);
  }, 100);
};
